import { render, staticRenderFns } from "./home-header.vue?vue&type=template&id=c23b8d70&scoped=true"
import script from "./home-header.vue?vue&type=script&lang=js"
export * from "./home-header.vue?vue&type=script&lang=js"
import style0 from "./home-header.vue?vue&type=style&index=0&id=c23b8d70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23b8d70",
  null
  
)

export default component.exports